import React, { useContext, useCallback } from 'react';
import { CustomersContext, ICustomersContext } from '../customersState/customersContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import Text from 'components/Text/Text';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, archiveSelectedItem, restoreSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<ICustomersContext>(CustomersContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteCustomer"
				typeOfInfoIcon="toDelete"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="deleteCustomerDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalToConfirm
				onConsentEvent={archiveSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmArchiveItem'}
				description="archiveCustomer"
				typeOfInfoIcon="toArchive"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="archiveCustomerDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'archiveSuccess'}
				description="archiveCustomerSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'archiveError'}
				description="errorWhileArchivingCustomer"
			/>
			<ModalToConfirm
				onConsentEvent={restoreSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmRestoreItem'}
				description="restoreCustomer"
				typeOfInfoIcon="toRestore"
				additionalContent={
					<Text
						className="mt-4"
						translationNameSpace="modals"
						translationKey="restoreCustomerDescription"
						size="m"
						weight="medium"
						align="center"
					/>
				}
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'restoreSuccess'}
				description="restoreCustomerSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'restoreError'}
				description="errorWhileRestoringCustomer"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteCustomerSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingCustomer"
			/>
		</ModalWrapper>
	);
};
